module.exports = __webpack_public_path__ + "img/incein-l-circle-3.36300cc0.svg";